import { render, staticRenderFns } from "./AddBundles.vue?vue&type=template&id=3cd540a8&"
import script from "./AddBundles.vue?vue&type=script&lang=js&"
export * from "./AddBundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports